import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent, CardMedia } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const PopularRoutes = () => {
  const { t } = useTranslation();

  const routes = [
    {
      title: t('routes.istanbul.title', 'İstanbul Havalimanı - Şehir Merkezi'),
      image: '/images/ist.webp',
      description: t('routes.istanbul.description', 'Yeni İstanbul Havalimanından şehir merkezine konforlu transfer.'),
      distance: '40 km',
      duration: '45 dk',
      delay: 0.2,
    },
    {
      title: t('routes.antalya.title', 'Antalya Havalimanı - Belek'),
      image: '/images/ant.webp',
      description: t('routes.antalya.description', 'Antalya Havalimanından Belek otellerine özel transfer.'),
      distance: '35 km',
      duration: '40 dk',
      delay: 0.4,
    },
    {
      title: t('routes.bursa.title', 'İstanbul - Bursa'),
      image: '/images/bursa.webp',
      description: t('routes.bursa.description', 'İstanbuldan Bursaya şehirler arası özel transfer.'),
      distance: '150 km',
      duration: '2 saat',
      delay: 0.6,
    },
  ];

  return (
    <Box
      id="routes"
      sx={{
        py: 8,
        backgroundColor: 'background.paper',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              mb: 6,
              fontWeight: 700,
              color: 'primary.main',
            }}
          >
            {t('routes.title')}
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {routes.map((route, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: route.delay }}
              >
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      transition: 'transform 0.3s ease-in-out',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={route.image}
                    alt={route.title}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h3" sx={{ fontWeight: 600 }}>
                      {route.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {route.description}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 2,
                        pt: 2,
                        borderTop: 1,
                        borderColor: 'divider',
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        {t('routes.distance')}: {route.distance}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {t('routes.duration')}: {route.duration}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PopularRoutes; 